import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    error: null,
    tags: null,
    allTags: null,
};

const slice = createSlice({
    name: 'liveTracking',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        // GET TAGS
        setTags(state, action) {
            state.isLoading = false;
            state.tags = action.payload;
        },
        // GET TAGS
        setAllTags(state, action) {
            state.isLoading = false;
            state.allTags = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getTags(url = '/admin/tag/live_position/tags') {
    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(url);
            dispatch(slice.actions.setTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAllTags(url = '/admin/tag/live_position/common?date_filter=week') {
    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(url);
            dispatch(slice.actions.setAllTags(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}